export default __webpack_public_path__ + "static/media/veryFamousPerson.03bb5f09.jpg";